import { useAuth0 } from '@auth0/auth0-react';
import axios, { type AxiosInstance } from 'axios';
import apiService from 'shared/service/api.service';
import { clearStepUp } from 'shared/utils/redirect-to-step-up';
import { config } from 'store/constants';
import urlJoin from 'url-join';

const legacyApiUrl = urlJoin(apiService.baseUrl, 'private_api');
const apiV2Url = urlJoin(apiService.baseUrl, 'private_api/v2');

export function withStepUpCleared(instance: AxiosInstance) {
  instance.interceptors.response.use(response => {
    clearStepUp();
    return response;
  });
  return instance;
}

export function usePublicAxiosInstance() {
  return axios.create({
    baseURL: apiV2Url,
    headers: {
      tenant: apiService.tenant,
    },
  });
}

export async function useAxiosInstance() {
  const { getAccessTokenSilently } = useAuth0();
  const token = await getAccessTokenSilently({
    authorizationParams: {
      audience: config.auth0.audience,
      scope: 'openid profile email offline_access',
    },
  });

  return withStepUpCleared(
    axios.create({
      baseURL: apiV2Url,
      headers: {
        tenant: apiService.tenant,
        Authorization: `Bearer ${token}`,
      },
    }),
  );
}

export async function useLegacyAxiosInstance() {
  const { getAccessTokenSilently } = useAuth0();
  const token = await getAccessTokenSilently({
    authorizationParams: {
      audience: config.auth0.audience,
      scope: 'openid profile email offline_access',
    },
  });

  return withStepUpCleared(
    axios.create({
      baseURL: legacyApiUrl,
      headers: {
        tenant: apiService.tenant,
        Authorization: `Bearer ${token}`,
      },
    }),
  );
}
